PayoutTermList; // @flow
/* eslint no-process-env:0 */
import React from "react";
import { Route, Switch, Link, BrowserRouter as Router } from "react-router-dom";
import PrivateRoute from "../components/privateRoute/PrivateRoute";
import Authorization from "./Authorization";

// import loginConnected from "../views/admin/login";
import DashboardConnected from "../views/admin/home";
import CategoriesConnected from "../views/admin/categories";
import ViewCategories from "../views/admin/categories/subcategories";
import EditCategories from "../views/admin/categories/editcategories";
import AddCategoryConnected from "../views/admin/categories/addCategory";
import CityStatus from "../views/admin/cityStatus";
import AddSubAdmin from "../views/admin/subAdmin/AddSubAdmin";
import AdminResetPassword from "../views/admin/subAdmin/AdminResetPassword";
import UserList from "../views/admin/subAdmin/UserList";
import CustomerList from "../views/admin/subAdmin/customerList";
import UserDetails from "../views/admin/subAdmin/UserDetails";
import AddMerchant from "../views/admin/merchant/AddMerchant";
import StoreMerchant from "../views/admin/merchant/StoreMerchant";
import MerchantList from "../views/admin/merchant/MerchantList";
import MerchantDetails from "../views/admin/merchant/MerchantDetails";
import W9Info from "../views/admin/merchant/W9Info";

import AddContract from "../views/admin/contract/AddContract";

import AddProduct from "../views/admin/product/AddProduct";
import EditProduct from "../views/admin/product/EditProduct";
import ProductList from "../views/admin/product/ProductList";

import AddAuction from "../views/admin/auction/AddAuction";
import EditAuction from "../views/admin/auction/EditAuction";
import AuctionList from "../views/admin/auction/AuctionList";

import ContractList from "../views/admin/contract/ContractList";
import ContractDetails from "../views/admin/contract/ContractDetails";
import DealList from "../views/admin/deal/DealList";
import EditDeal from "../views/admin/deal/EditDeal";
import OfferOrder from "../views/admin/deal/OfferOrder";

import AddPromo from "../views/admin/promoCode/AddPromo";
import PromoList from "../views/admin/promoCode/PromoList";

import EditSite from "../views/admin/manageSite";
import Site from "../views/site";
import AddAffiliate from "../views/admin/marketing/affiliates/AddAffiliate";
import AffiliateList from "../views/admin/marketing/affiliates/AffiliateList";

import MerchantDashboard from "../views/merchant/dashboard";
import AffiliateDashboard from "../views/affiliate/dashboard";

import VoucherList from "../views/admin/voucher/VouchersList";
import ArchivevoucherList from "../views/admin/voucher/ArchivevouchersList";
import OrderHistory from "../views/admin/voucher/OrderHistory";

import GenerateVoucher from "../views/admin/voucher/GenerateVoucher";
import MerchantVoucherlist from "../views/merchant/voucher/List";
import EditVoucher from "../views/merchant/voucher/EditVoucher";

import MerchantArchiveVoucherlist from "../views/merchant/archivevoucher/List";
import EditArchiveVoucher from "../views/merchant/archivevoucher/EditVoucher";
import ViewContract from "../views/merchant/contract/View";
import SampleVoucher from "../views/merchant/voucher/SampleVoucher";
import TrackingNumber from "../views/merchant/trackingNumbers/Upload";
import TrackingNumberList from "../views/merchant/trackingNumbers/List";
import PrintVoucher from "../views/merchant/voucher/Print";
import CitiesPermission from "../views/admin/subAdmin/citiesPermission/CitiesPermission";
import SalesPersonQuestions from "../views/salesPerson/question/List";
import SalesPersonQuestAnswer from "../views/salesPerson/question/Add";
import PaymentSetting from "../views/admin/paymentSetting/PaymentSetting";
import SalesPersonProgressReport from "../views/salesPerson/salesTeam/progress/Progress";
import SalesReport from "../views/admin/reports/SalesReport";
import RefundReport from "../views/admin/reports/RefundReports";
import RefundArchiveReport from "../views/admin/reports/RefundArchiveReports";
import TransactionReport from "../views/admin/reports/TransactionReports";
import TransactionarchiveReport from "../views/admin/reports/TransactionarchiveReports";
import CustomerRecurring from "../views/admin/reports/CustomerRecurring";
import RecurringPayment from "../views/admin/reports/RecurringPayment";
import SuccessRecurring from "../views/admin/reports/SuccessRecurring";
import FailedRecurring from "../views/admin/reports/FailedRecurring";
import SimpleTransaction from "../views/admin/reports/SimpleTransaction";
import MerchantPayout from "../views/admin/reports/MerchantPayout";
import EmailSetting from "../views/admin/emailSetting";
import EmailTempelate from "../views/admin/emailTempelate";
import UpdateEmailTempelate from "../views/admin/emailTempelate/updateEmailTempelate";
import ManageTermsPolicies from "../views/admin/manageTermsPolicies";
import OfferReviews from "../views/admin/offerReview/OfferReviewList";
import EditOfferReview from "../views/admin/offerReview/EditOfferReview";
import AddFaq from "../views/admin/faq/addFaq";
import FaqList from "../views/admin/faq/faqList";
import QuestionList from "../views/admin/question/QuestionList";
import GiveAnswer from "../views/admin/question/GiveAnswer";
import designCenterRoutes from "../views/admin/designCenter/designCenterRoute";

import Overview from "../views/admin/EmailManager/Overview";
import CustomEmail from "../views/admin/EmailManager/custom/CustomEmail";
import MultiOfferEmail from "../views/admin/EmailManager/multi/MultiOffer";
import OfferEmail from "../views/admin/EmailManager/offer/ChooseOffer";
import CreateOfferEmail from "../views/admin/EmailManager/common/OfferMail";
import ContractEmail from "../views/admin/contract/SendMail";
import AllUser from "../views/admin/user/UserList";
import StoreCreditPreview from "../views/admin/user/StoreCreditPreview";
import SearchConnected from "../views/admin/dashboard/Search";
import PageTemplate from "../views/admin/pageTemplate/PageTemplate";
import EditPageTemplate from "../views/admin/pageTemplate/EditPageTemplate";
import FormSetting from "../views/admin/setting/FormSetting";
import AclSettings from "../views/admin/subAdmin/AclSettings";
import RestrictedAccess from "../views/RestrictedAccess";
import PrintVouchers from "../views/admin/voucher/PrintVouchers";
import ExportSubscriber from "../views/admin/EmailManager/ExportSubscriber";
import ImportSubscriber from "../views/admin/EmailManager/ImportSubscriber";
import AddPayoutTerms from "../views/admin/payoutTerms/AddPayoutTerms";
import PayoutTermList from "../views/admin/payoutTerms/PayoutTermList";
import EditPayoutTerms from "../views/admin/payoutTerms/EditPayoutTerms";
import SiteLookup from "../views/admin/generalSearch/SiteLookup";
import BuyerMetrics from "../views/admin/reports/BuyerMetrics";
import RevenueReports from "../views/admin/reports/RevenueReports";
import NetRevenue from "../views/admin/reports/NetRevenue";
import Invoice from "../views/admin/reports/Invoice";
import SalesPerformance from "../views/admin/reports/SalesPerformance";
import MerchantPayoutPaid from "../views/admin/reports/MerchantPayoutPaid";
import MerchantPayoutByOffer from "../views/admin/reports/MerchantPayoutByOffer";
import SalesByOffer from "../views/admin/reports/SalesByOffer";
import DealBuyer from "../views/admin/reports/DealBuyer";
import CouponOffers from "../views/admin/reports/CouponOffers";
import MerchantPayon from "../views/admin/reports/MerchantPayon";
import SalesOverview from "../views/admin/reports/SalesOverview";
import OfferInventory from "../views/admin/reports/OfferInventory";
import EmployeeCommissions from "../views/admin/reports/EmployeeCommissions";
import OtherFormSetting from "../views/admin/setting/OtherFormSetting";
import NotificationList from "../views/admin/notification/NotificationList";
import AddNotification from "../views/admin/notification/AddNotification";
import EditNotification from "../views/admin/notification/EditNotification";
import UploadedVoucher from "../views/admin/deal/LoadVoucher";

import AffiliateCommissions from "../views/admin/reports/AffiliateCommissions";
import EmailSubscribers from "../views/admin/reports/EmailSubscribers";
import ExportUsers from "../views/admin/user/ExportUsers";
import ApiSetting from "../views/admin/setting/ApiSetting";
import CartSetting from "../views/admin/setting/CartSetting";
import AccountSetting from "../views/admin/setting/AccountSetting";
import AddCharity from "../views/admin/charity/AddCharity";
import CharityList from "../views/admin/charity/CharityList";
import EditCharity from "../views/admin/charity/EditCharity";
import AddCityPassword from "../views/admin/citypassword/AddCityPassword";
import EditCityPassword from "../views/admin/citypassword/EditCityPassword";
import CityPasswordList from "../views/admin/citypassword/CityPasswordList";
import SeoSetting from "../views/admin/setting/SeoSetting";
import AddRole from "../views/admin/role/AddRole";
import RoleList from "../views/admin/role/RoleList";
import EditRole from "../views/admin/role/EditRole";
import FooterTemplate from "../views/admin/pageTemplate/FooterTemplate";
import HeaderTemplate from "../views/admin/pageTemplate/HeaderTemplate";
import AddMarket from "../views/admin/campaignMarket/Add";
import ListMarket from "../views/admin/campaignMarket/List";
import EditMarket from "../views/admin/campaignMarket/Edit";
import AddPostup from "../views/admin/postup/Add";
import ListPostup from "../views/admin/postup/List";
import EditPostup from "../views/admin/postup/Edit";
import DealBuyerList from "../views/merchant/buyerlist/DealBuyerList";
import PayableList from "../views/merchant/payable/PayableList";
import UpdateSubscription from "../views/admin/generalSearch/UpdateSubscription";
import AnnouncementsList from "../views/admin/announcements/AnnouncementsList";
import PrintarchiveVouchers from "../views/admin/voucher/PrintarchiveVouchers";
import PrintarchiveVoucher from "../views/merchant/archivevoucher/Print";
import ZeorSaleByOffer from "../views/admin/reports/ZeroSaleByOffer";

const Admin = Authorization([
  "admin",
  "subadmin",
  localStorage.getItem("userTypeName"),
]);
const Sales = Authorization([
  "admin",
  "subadmin",
  "salesmanager",
  "finance",
  "merchant",
  localStorage.getItem("userTypeName"),
]);
const Merchant = Authorization([
  "admin",
  "subadmin",
  "merchant",
  localStorage.getItem("userTypeName"),
]);
const SuperAdmin = Authorization([
  "superadmin",
  "admin",
  localStorage.getItem("userTypeName"),
]);

const MainRoutes = () => (
  <Switch>
    <Route
      authorize={["admin", "superadmin", "merchant", "finance"]}
      exact
      path="/dashboard"
      component={DashboardConnected}
    />
    <Route
      authorize={["merchant", "admin"]}
      exact
      path="/merchant/dashboard/:user_id?"
      component={MerchantDashboard}
    />
    <Route
      authorize={["admin", "affiliate"]}
      exact
      path="/affiliate/dashboard/:affiliateID"
      component={AffiliateDashboard}
    />
    <Route
      exact
      path="/search/:filterType?/:filterText?"
      component={SearchConnected}
    />
    <Route exact path="/addFaq" component={AddFaq} />
    <Route exact path="/editFaq/:quesID?" component={AddFaq} />
    <Route exact path="/faqList" component={FaqList} />
    <Route exact path="/giveAnswer/:quesID?" component={GiveAnswer} />
    <Route exact path="/questions" component={QuestionList} />
    <Route exact path="/categories" component={CategoriesConnected} />
    <Route exact path="/manageTermsPolicies" component={ManageTermsPolicies} />
    <Route exact path="/cityStatus" component={CityStatus} />
    <Route exact path="/addSubAdmin" component={Admin(AddSubAdmin)} />
    <Route exact path="/addSubAdmin/:userId?" component={Admin(AddSubAdmin)} />
    <Route
      exact
      path="/admin/resetPassword/:userId?"
      component={Admin(AdminResetPassword)}
    />
    <Route exact path="/acl/settings/:userId?" component={Admin(AclSettings)} />
    <Route exact path="/emailSetting" component={EmailSetting} />
    <Route
      exact
      path="/editOfferReview/:reviewID?"
      component={EditOfferReview}
    />
    <Route exact path="/emailTemplate" component={EmailTempelate} />
    <Route
      exact
      path="/updateEmailTemplate/:tempelateID?"
      component={UpdateEmailTempelate}
    />
    <Route exact path="/addSubAdmin/:userId?" component={AddSubAdmin} />
    <Route exact path="/editSite" component={EditSite} />
    <Route exact path="/userList" component={UserList} />
    <Route exact path="/customerList" component={CustomerList} />
    <Route exact path="/userDetails/:userId?" component={UserDetails} />
    <Route exact path="/addMerchant" component={Sales(AddMerchant)} />
    <Route exact path="/addMerchant/:userId?" component={Sales(AddMerchant)} />
    <Route exact path="/storeMerchant/:userId?" component={StoreMerchant} />
    <Route exact path="/offerReviews" component={OfferReviews} />
    <Route exact path="/merchantList" component={Sales(MerchantList)} />
    <Route
      exact
      path="/merchantDetails/:userId?"
      component={Sales(MerchantDetails)}
    />
    <Route
      exact
      path="/merchant/w9info/:merchantID?"
      component={Sales(W9Info)}
    />
    <Route
      path="/categories/addCategory"
      component={Admin(AddCategoryConnected)}
    />
    <Route
      path="/addCategory/:catID?"
      component={Admin(AddCategoryConnected)}
    />
    <Route
      exact
      path="/viewcategories/:catID?"
      component={Admin(ViewCategories)}
    />
    <Route
      exact
      path="/viewcategories/:catID?/:subcatID?"
      component={Admin(ViewCategories)}
    />
    <Route
      path="/categories/editcategories/"
      component={Admin(EditCategories)}
    />
    <Route exact path="/addContract" component={Sales(AddContract)} />
    <Route
      exact
      path="/addContract/:contractId?/:cType?"
      component={Sales(AddContract)}
    />
    <Route
      exact
      path="/contractList/:merchantID?"
      component={Sales(ContractList)}
    />
    <Route
      exact
      path="/contractDetails/:contractId?"
      component={Sales(ContractDetails)}
    />
    <Route exact path="/addProduct" component={Sales(AddProduct)} />
    <Route
      exact
      path="/addProduct/:contractId?/:cType?"
      component={Sales(AddProduct)}
    />
    <Route exact path="/addAuction" component={Sales(AddAuction)} />
    <Route
      exact
      path="/addAuction/:contractId?/:cType?"
      component={Sales(AddAuction)}
    />
    <Route exact path="/addPromo" component={AddPromo} />
    <Route exact path="/addPromo/:promoID?" component={AddPromo} />
    <Route exact path="/promoList" component={PromoList} />
    <Route exact path="/addAffiliate" component={AddAffiliate} />
    <Route exact path="/addAffiliate/:affiliateID?" component={AddAffiliate} />
    <Route exact path="/affiliateList" component={AffiliateList} />
    <Route exact path="/payment-setting" component={PaymentSetting} />
    <Route exact path="/dealList/:merchantID?" component={Sales(DealList)} />
    <Route
      exact
      path="/productList/:merchantID?"
      component={Sales(ProductList)}
    />
    <Route
      exact
      path="/auctionList/:merchantID?"
      component={Sales(AuctionList)}
    />
    <Route exact path="/editDeal/:dealID?" component={Sales(EditDeal)} />
    <Route exact path="/editProduct/:dealID?" component={Sales(EditProduct)} />
    <Route exact path="/editAuction/:dealID?" component={Sales(EditAuction)} />
    <Route exact path="/offerOrder" component={Sales(OfferOrder)} />
    <Route exact path="/report/sales" component={SalesReport} />
    <Route exact path="/report/refund" component={RefundReport} />
        <Route exact path="/report/archiverefund" component={RefundArchiveReport} />
    <Route exact path="/report/transaction" component={TransactionReport} />\
    <Route exact path="/report/alltransaction" component={TransactionarchiveReport} />
    <Route
      exact
      path="/report/CustomerRecurring"
      component={CustomerRecurring}
    />
    <Route exact path="/report/RecurringPayment" component={RecurringPayment} />
    <Route exact path="/report/SuccessRecurring" component={SuccessRecurring} />
    <Route exact path="/report/FailedRecurring" component={FailedRecurring} />
    <Route
      exact
      path="/report/simpletransaction"
      component={SimpleTransaction}
    />
    <Route exact path="/report/merchant-payout" component={MerchantPayout} />

       <Route exact path="/report/zerosale-by-offer" component={ZeorSaleByOffer} />

    
    <Route exact path="/voucherList/:userId?" component={VoucherList} />
    <Route exact path="/orders/:userId?" component={OrderHistory} />
    <Route
      exact
      path="/archivevoucherLists/:userId?"
      component={ArchivevoucherList}
    />
    <Route exact path="/printVouchers/:voucherId?" component={PrintVouchers} />
    <Route
      exact
      path="/printarchiveVouchers/:voucherId?"
      component={PrintarchiveVouchers}
    />
    <Route exact path="/generateVoucher" component={GenerateVoucher} />
    <Route exact path="/api-settings" component={ApiSetting} />
    <Route exact path="/cart-setting" component={CartSetting} />
    <Route exact path="/account-settings" component={AccountSetting} />
    <Route exact path="/charity-setting" component={AddCharity} />
    <Route exact path="/charity/list" component={CharityList} />
    <Route
      exact
      path="/edit-charity-setting/:charityID?"
      component={EditCharity}
    />
    <Route exact path="/city-password/add" component={AddCityPassword} />
    <Route
      exact
      path="/city-password/edit/:citypasswordID?"
      component={EditCityPassword}
    />
    <Route exact path="/city-password" component={CityPasswordList} />
    <Route exact path="/announcements" component={AnnouncementsList} />
    <Route exact path="/seo-settings" component={SeoSetting} />
    <Route exact path="/add-role" component={AddRole} />
    <Route exact path="/role-list" component={RoleList} />
    <Route exact path="/edit-role/:userTypeID" component={EditRole} />
    <Route exact path="/market/add" component={AddMarket} />
    <Route exact path="/market/list" component={ListMarket} />
    <Route exact path="/market/edit/:marketID?" component={EditMarket} />
    <Route exact path="/postup/add" component={AddPostup} />
    <Route exact path="/postup/list" component={ListPostup} />
    <Route exact path="/postup/edit/:postupID?" component={EditPostup} />
    <Route exact path="/deal-buyer-list" component={DealBuyerList} />
    <Route exact path="/payables" component={PayableList} />
    <Route
      exact
      path="/merchant/voucher/list"
      component={Merchant(MerchantVoucherlist)}
    />
    <Route
      exact
      path="/merchant/voucher/list/:userID?"
      component={Merchant(MerchantVoucherlist)}
    />

     <Route
      exact
      path="/merchant/archivevoucher/list"
      component={Merchant(MerchantArchiveVoucherlist)}
    />
    <Route
      exact
      path="/merchant/archivevoucher/list/:userID?"
      component={Merchant(MerchantArchiveVoucherlist)}
    />
    <Route
      exact
      path="/editVoucher/:voucherID?"
      component={Merchant(EditVoucher)}
    />
    <Route
      exact
      path="/editVoucher/:voucherID/:userID?"
      component={Merchant(EditVoucher)}
    />
    <Route
      exact
      path="/editarchiveVoucher/:voucherID?"
      component={Merchant(EditArchiveVoucher)}
    />
    <Route
      exact
      path="/editarchiveVoucher/:voucherID/:userID?"
      component={Merchant(EditArchiveVoucher)}
    />

   
    <Route
      exact
      path="/voucher/list/print/:dealID?"
      component={Merchant(PrintVoucher)}
    />

     <Route
      exact
      path="/archivevoucher/list/print/:dealID?"
      component={Merchant(PrintarchiveVoucher)}
    />


    
    <Route exact path="/contract/view" component={Merchant(ViewContract)} />
    <Route
      exact
      path="/contract/view/:userID?"
      component={Merchant(ViewContract)}
    />
    <Route
      exact
      path="/samplevoucher/:dealID?"
      component={Merchant(SampleVoucher)}
    />
    <Route
      exact
      path="/samplevoucher/:dealID/:userID?"
      component={Merchant(SampleVoucher)}
    />
    <Route
      exact
      path="/upload/trackingnumbers/:dealID?"
      component={Merchant(TrackingNumber)}
    />
    <Route
      exact
      path="/upload/trackingnumbers/:dealID/:userID?"
      component={Merchant(TrackingNumber)}
    />
    <Route
      exact
      path="/trackingnumbers/List"
      component={Merchant(TrackingNumberList)}
    />
    <Route
      exact
      path="/trackingnumbers/List/:userID?"
      component={Merchant(TrackingNumberList)}
    />
    <Route
      exact
      path="/cities/permission/:id?"
      component={Admin(CitiesPermission)}
    />
    <Route
      exact
      path="/cities/permission/:edit/:id?"
      component={Admin(CitiesPermission)}
    />
    <Route
      exact
      path="/question/pending"
      component={Sales(SalesPersonQuestions)}
    />
    <Route
      exact
      path="/question/edit/:quesID?"
      component={Sales(SalesPersonQuestAnswer)}
    />
    <Route
      exact
      path="/team/progress"
      component={Sales(SalesPersonProgressReport)}
    />
    <Route exact path="/email-manager/overview" component={Overview} />
    <Route
      exact
      path="/email-manager/customemail/:campaignID?"
      component={CustomEmail}
    />
    <Route
      exact
      path="/email-manager/multiofferemail/:campaignID?"
      component={MultiOfferEmail}
    />
    <Route
      exact
      path="/email-manager/offeremail/:campaignID?"
      component={OfferEmail}
    />
    <Route
      exact
      path="/email-manager/create-offer-email/:dealID?/:campaignID?"
      component={CreateOfferEmail}
    />
    <Route
      exact
      path="/contract-mail/:contractID?/:merchantID?"
      component={ContractEmail}
    />
    <Route exact path="/store-credit/:userID?" component={AllUser} />
    <Route
      exact
      path="/store-credit-preview/:userID?"
      component={StoreCreditPreview}
    />
    <Route path="/page-template" component={PageTemplate} />
    <Route
      exact
      path="/edit-page-template/:templateType?"
      component={EditPageTemplate}
    />
    <Route
      exact
      path="/form-setting/become-a-partner"
      component={FormSetting}
    />
    <Route exact path="/restrictedAccess" component={RestrictedAccess} />
    <Route exact path="/export-subscriber" component={ExportSubscriber} />
    <Route exact path="/import-subscriber" component={ImportSubscriber} />
    <Route exact path="/payout-terms/add" component={AddPayoutTerms} />
    <Route exact path="/payout-terms/list" component={PayoutTermList} />
    <Route
      exact
      path="/payout-terms/edit/:termID?"
      component={EditPayoutTerms}
    />
    <Route exact path="/sitelookup" component={SiteLookup} /> //Changed
    Admin(SiteLookup)
    <Route exact path="/report/buyer" component={BuyerMetrics} />
    <Route exact path="/report/revenue" component={RevenueReports} />
    <Route exact path="/report/netrevenue" component={NetRevenue} />
    <Route exact path="/report/invoice" component={Invoice} />
    <Route
      exact
      path="/report/sales-performance"
      component={SalesPerformance}
    />
    <Route exact path="/report/payout-paid" component={MerchantPayoutPaid} />
    <Route
      exact
      path="/report/payout-by-offer"
      component={MerchantPayoutByOffer}
    />
    <Route exact path="/report/sales-by-offer" component={SalesByOffer} />
    <Route exact path="/report/merchant-payon" component={MerchantPayon} />
    <Route exact path="/report/sales-overview" component={SalesOverview} />
    <Route exact path="/report/offer-inventory" component={OfferInventory} />
    <Route exact path="/report/commissions" component={EmployeeCommissions} />
    <Route
      exact
      path="/report/affiliate/commissions"
      component={AffiliateCommissions}
    />
    <Route
      exact
      path="/report/email/subscribers"
      component={EmailSubscribers}
    />
    <Route exact path="/report/dealbuyer" component={DealBuyer} />
    <Route exact path="/report/couponoffers" component={CouponOffers} />
    <Route exact path="/form-setting/reg-subs" component={OtherFormSetting} />
    <Route exact path="/notification/list" component={NotificationList} />
    <Route exact path="/notification/add" component={AddNotification} />
    <Route exact path="/notification/edit/:id?" component={EditNotification} />
    <Route
      exact
      path="/uploaded-vouchers/:dealID?"
      component={UploadedVoucher}
    />
    <Route exact path="/export/users" component={ExportUsers} />
    <Route exact path="/footer-template" component={FooterTemplate} />
    <Route exact path="/header-template" component={HeaderTemplate} />
    <Route
      exact
      path="/subscriber-edit/:subscriberID?"
      component={UpdateSubscription}
    />
    {designCenterRoutes}
    {/*<Route path="/general/breadcrumb" component={BreadcrumbViewConnected} />
    <Route path="/general/stat" component={StatViewConnected} />*/}
    {/*<Route
          path="/general/basicProgressBars"
          component={BasicProgressBarConnected}
        />
    <Route path="/general/tabPanels" component={TabPanelConnected} />
    <Route
      path="/general/stripedProgressBars"
      component={StripedProgressBarConnected}
    />
    <Route path="/general/alerts" component={AlertConnected} />
    <Route path="/general/pagination" component={PaginationViewConnected} />*/}
  </Switch>
);

export default MainRoutes;



// WEBPACK FOOTER //
// ./src/app/routes/MainRoutes.js